/**
 * HEMS 네이티브 앱 브릿지
 * - legacy Android WebView: window.Android
 * - Capacitor (Android/iOS): @capacitor/preferences
 * - 일반 브라우저: no-op
 */

const PREFS_KEY_ACCESS_TOKEN = "hems_access_token";

function isCapacitor() {
    return (
        typeof window !== "undefined" &&
        window.Capacitor &&
        typeof window.Capacitor.isNativePlatform === "function" &&
        window.Capacitor.isNativePlatform()
    );
}

function isLegacyAndroidWebView() {
    return typeof window !== "undefined" && typeof window.Android !== "undefined" && window.Android;
}

function isNativeHemsApp() {
    return isCapacitor() || isLegacyAndroidWebView();
}

async function getLegacyAutoLoginJson() {
    if (!isLegacyAndroidWebView() || !window.Android.getAutoLogin) {
        return null;
    }
    try {
        return window.Android.getAutoLogin() || null;
    } catch (e) {
        console.warn("[mobileBridge] legacy getAutoLogin failed", e);
        return null;
    }
}

async function getLegacyAutoLoginCredentials() {
    const json = await getLegacyAutoLoginJson();
    if (!json) {
        return null;
    }
    try {
        const user = JSON.parse(json);
        if (user.masterCode && user.userId && user.password) {
            return {
                masterCode: user.masterCode,
                userId: user.userId,
                password: user.password,
            };
        }
    } catch (e) {
        console.warn("[mobileBridge] legacy auto login parse failed", e);
    }
    return null;
}

async function saveLegacyAutoLogin(masterCode, userId, password) {
    if (!isLegacyAndroidWebView() || !window.Android.setPreference) {
        return;
    }
    try {
        window.Android.setPreference(masterCode, userId, password);
    } catch (e) {
        console.warn("[mobileBridge] legacy setPreference failed", e);
    }
}

async function saveAccessToken(accessToken) {
    if (!isCapacitor() || !accessToken) {
        return;
    }
    try {
        const { Preferences } = await import("@capacitor/preferences");
        await Preferences.set({ key: PREFS_KEY_ACCESS_TOKEN, value: accessToken });
    } catch (e) {
        console.warn("[mobileBridge] saveAccessToken failed", e);
    }
}

async function getSavedAccessToken() {
    if (!isCapacitor()) {
        return null;
    }
    try {
        const { Preferences } = await import("@capacitor/preferences");
        const { value } = await Preferences.get({ key: PREFS_KEY_ACCESS_TOKEN });
        return value || null;
    } catch (e) {
        console.warn("[mobileBridge] getSavedAccessToken failed", e);
        return null;
    }
}

async function clearSavedAccessToken() {
    if (!isCapacitor()) {
        return;
    }
    try {
        const { Preferences } = await import("@capacitor/preferences");
        await Preferences.remove({ key: PREFS_KEY_ACCESS_TOKEN });
    } catch (e) {
        console.warn("[mobileBridge] clearSavedAccessToken failed", e);
    }
}

export default {
    isCapacitor,
    isLegacyAndroidWebView,
    isNativeHemsApp,
    getLegacyAutoLoginCredentials,
    saveLegacyAutoLogin,
    saveAccessToken,
    getSavedAccessToken,
    clearSavedAccessToken,
};
